var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.619 10.9985L19.8221 1.22041C19.9596 1.05791 19.844 0.811035 19.6315 0.811035H17.1378C16.9909 0.811035 16.8503 0.87666 16.7534 0.98916L9.98775 9.05478L3.22213 0.98916C3.12838 0.87666 2.98775 0.811035 2.83775 0.811035H0.344001C0.131501 0.811035 0.0158753 1.05791 0.153375 1.22041L8.3565 10.9985L0.153375 20.7767C0.122574 20.8129 0.102814 20.8572 0.09644 20.9043C0.0900661 20.9514 0.0973463 20.9994 0.117417 21.0425C0.137488 21.0856 0.169506 21.122 0.209669 21.1475C0.249833 21.1729 0.296455 21.1863 0.344001 21.186H2.83775C2.98463 21.186 3.12525 21.1204 3.22213 21.0079L9.98775 12.9423L16.7534 21.0079C16.8471 21.1204 16.9878 21.186 17.1378 21.186H19.6315C19.844 21.186 19.9596 20.9392 19.8221 20.7767L11.619 10.9985Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.80b1f8abf3c9527a3720d3369f4d5e14.svg";
export { ForwardRef as ReactComponent };